import { getMyOcBasePath } from '@cx-web/utils';

import { type Repub } from '@cx-modules/constants';

export * from './constants';
export * from './isRedirect';
export * from './types';
export * from './utils';

export function logout(repub: Repub, redirectUrl: string): void {
  const options = {
    method: 'POST',
    headers: {
      'OC-Repub': repub,
      'Content-Type': 'application/json',
    },
    credentials: 'include' as RequestCredentials,
  };

  // The logout endpoint moved from RR7 atlas (`/api/cx/myoc/v2/logout`) to the repub-prefixed
  // myoddschecker namespace (`/{repub}/myoddschecker/logout`) in NGF-6477.
  //
  // WS is the exception (SPOR-2292): whoscored.com's edge only forwards `/plus*` and `/api/*` to
  // cx-web (its legacy ASP.NET origin answers the myoddschecker path with its own 404), and the
  // myoddschecker endpoint clears on the BASE_URL-derived domain (`.oddschecker.com`), which can
  // never match the `.whoscored.com` cookie plus's login wrote. WS therefore posts to
  // product-plus's own logout action (`apps/product-plus/app/templates/auth/logout.ts`), which
  // clears on the request-host-derived scope. The branch lives HERE, not in getMyOcBasePath —
  // that helper's other consumers append `/profile`/`/settings`, which must not resolve onto the
  // plus auth tree.
  const logoutPath = repub === 'WS' ? '/plus/auth/logout' : `${getMyOcBasePath(repub)}/logout`;
  fetch(logoutPath, options).finally(() => {
    window.location.href = redirectUrl;
  });
}
